import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios'
import {getuserInfo} from "@/api/index.js"

Vue.use(Vuex);

let defaultLogined = false;
try {
  if (localStorage.isLogin || localStorage.isLogin == "true") {
    defaultLogined = JSON.parse(localStorage.isLogin);
  }
} catch (e) {
}

// 创建vuex的store
const store = new Vuex.Store({
  state: {
    LoginShow:false,
    RegisterShow:false,
    ForgetPassShow:false,
    IsLogin:defaultLogined,
    userObj:localStorage["userObj"] ? JSON.parse(localStorage["userObj"]) : '',
    infoData: localStorage["gwInfoData"] ? JSON.parse(localStorage["gwInfoData"]) : '',
  },
  mutations: {
    ChangeRegisShow(state){
      state.RegisterShow = !state.RegisterShow;
    },
    ChangeLoginShow(state){
      state.LoginShow = !state.LoginShow;
    },
    ChangeForgetPassShow(state){
      state.ForgetPassShow = !state.ForgetPassShow;
    },
    CutLogin (state) {
      state.IsLogin = true;
      localStorage.setItem("isLogin",true);
    },
    LoginOut (state) {
      state.IsLogin = false;
      state.userObj = null;
      try {
        localStorage.removeItem("isLogin");
        localStorage.removeItem("userObj");
        localStorage.removeItem("token");
      } catch (e) {
      }
    },
    //用户信息
    UserObjState(state, data) {
      state.userObj = data;
      localStorage.setItem("userObj", JSON.stringify(state.userObj));
    },
    setWebConfig(state, data){
      state.infoData = data;
      localStorage.setItem("gwInfoData",JSON.stringify(state.infoData));
    },
    setData(state, params) {
      Object.keys(params).forEach(key => {
        // 需要替换的值
        const val = params[key];
        const arr = key.split(".");
        if (arr.length > 1) {
          let obj = state;
          while ((arr.length - 1) && (obj = obj[arr.shift()]));
          obj[arr[0]] = val;
        } else {
          state[key] = val;
        }
      })
    }
  },
  actions: {
    getuser(context, data) {
      let url = '/user/getUser';
      getuserInfo({}).then((res) => {
        if (res.status == 200) {
          if (res.data.user) {
            context.commit('UserObjState', res.data.user);
          }
        }
      });
    },
    //网站配置信息
    getWebConfig(context, data){
      axios({
        method: "GET",
          url: "/appConfig/dataByTypeKey",
          data:{
            typeKey: 'extraParamConfig'
          }
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.success) {
            context.commit('setWebConfig', JSON.parse(res.data.obj));
          }
        }
      });
    },
    CutLogin (ctx) {
      ctx.commit('CutLogin');
    },
    OutLogin(ctx) {
      ctx.commit('LoginOut');
    },
    ChangeForgetPassShow(ctx){
      ctx.commit('ChangeForgetPassShow');
    },
    ChangeRegisShow(ctx){
      ctx.commit('ChangeRegisShow');
    },
    ChangeLoginShow(ctx){
      ctx.commit('ChangeLoginShow');
    },
  },
  getters: {}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js